export const ConvertSecondToHour = second => {
  second = Number(second);
  var h = Math.floor(second / 3600);
  var m = Math.floor((second % 3600) / 60);
  var s = Math.floor((second % 3600) % 60);
  return (
    ('0' + h).slice(-2) + ':' + ('0' + m).slice(-2) + ':' + ('0' + s).slice(-2)
  );
};
